var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"background-overlay d-flex justify-center align-center"},[_c('img',{attrs:{"src":require(`@/assets/Naccc-loader.gif`),"width":"100","height":"100"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }